import httpClient from "@/plugins/axios";

export const getResources = async (page, pageSize = 10, folderId = null) => {
    let url = `/v2/resources/?page=${page}&page_size=${pageSize}`;
    if (folderId) {
        url += `&folder=${folderId}`;
    }
    const response = await httpClient.get(url);
    return response;
}

export const download = async (id) => {
    const response = await httpClient.get(`/v1/resources/${id}/view/`,
        {
            responseType: 'blob',
        });
    return response;
}

export const getResource = async (id) => {
    const response = await httpClient.get(`/v1/resources/${id}/`);
    return response;
}
